<template>
    <div class="expandy-children" :class="{expanded: expanded || !collapsedHeight}">
        <div class="expandy-sleeve" :style="styles">
            <slot></slot>
        </div>
        <div class="expandy-toggler" @click="expanded = !expanded" v-if="collapsedHeight !== null && !expanded">
            <span>Show all {{ label }} (+{{ totalItems - visibleItems }})</span><svg-icon id="chevronDown"></svg-icon>
        </div>
        <div class="expandy-toggler" @click="expanded = !expanded" v-if="collapsedHeight !== null && expanded">
            <span>Hide {{ totalItems - visibleItems }} {{ label }}</span><svg-icon id="chevronUp"></svg-icon>
        </div>
    </div>
</template>

<script>
export default {
    
    props: {
        
        childSelector: {
            type:       String,
            default:    '.column',
        },
        
		label: {
			type:		String,
            default:    'items',
		},
        
		rows: {
			type:       Number,
            default:    3,
		},
        
        src: {
        },
        
    },
    
    data() {
		return {
            collapsedHeight:    null,
			expanded:	        false,
            fullHeight:         null,
            visibleItems:       0,
            totalItems:         0,
        };
    },
    
    computed: {
        styles() {
            if ( this.collapsedHeight !== null ) {
                return {
                    'max-height':   ((!this.expanded) ? this.collapsedHeight : this.fullHeight) + 'px',
                };
            }
            
            return {};
        },
    },
    
    watch: {
        src: {
            handler() {
                this.recalculateRows();
            },
            deep: true,
        },
    },
    
    mounted() {
        this.recalculateRows();
    },
    
    
    
    methods: {
        recalculateRows() {
            let children = Array.from(this.$el.querySelectorAll(':scope ' + this.childSelector));
            let rows_found = 0;
            let last_y = null;
            this.visibleItems = 0;
            this.totalItems = children.length;
            this.fullHeight = this.collapsedHeight = null;
            
            for ( let child of children ) {
                if ( last_y !== null && last_y < child.offsetTop ) {
                    rows_found++;
                    
                    if ( (rows_found >= this.rows) && !this.collapsedHeight ) {
                        this.collapsedHeight = child.offsetTop;
                    }
                }
                
                if ( !this.collapsedHeight ) {
                    this.visibleItems++;
                }
                
                this.fullHeight = child.offsetTop + child.offsetHeight;
                last_y = child.offsetTop;
            }
        },
    },
    
};
</script>